import { z } from 'zod';
import { REST_ENDPOINTS } from '@/constants';
import { fetchClient } from '@/lib/fetchClient';
import type { ReleaseNotesResponse } from '../types';

const releaseNoteItemSchema = z.object({
  id: z.string(),
  featureType: z.enum(['New Feature', 'Enhancement']),
  date: z.string(),
  sprint: z.number(),
  audience: z.string(),
  title: z.string(),
  bodyMd: z.string(),
  sortOrder: z.number(),
});

const releaseNotesResponseSchema = z.object({
  items: z.array(releaseNoteItemSchema),
});

export async function fetchReleaseNotes(signal?: AbortSignal): Promise<ReleaseNotesResponse> {
  const response = await fetchClient(REST_ENDPOINTS.RELEASE_NOTES, { signal });
  const json = await response.json();
  return releaseNotesResponseSchema.parse(json);
}
